exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nsvg path[data-v-7c1c295c] {\n\t/*fill: blue;*/\n}\n", ""]);

// exports
